import {Directive, effect, ElementRef, HostListener, input, output, Renderer2} from '@angular/core';

@Directive({
  selector: '[appSeeMoreScroll]',
})
export class SeeMoreScrollDirective {
  seeMoreScrollContent = input<string>('');
  seeMoreForceShow = input<boolean>(false);
  elementCssClass = input<string>('see-more-scroll title-7');
  scrollDownClicked = output<boolean>();

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {
    effect(() => {
      this.insertLasMer();
    });
  }

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    const target = $event.target as HTMLElement;
    if (target.className === this.elementCssClass()) {
      this.scrollDownClicked.emit(true);
    }
  }

  private insertLasMer(): void {
    const nativeElement = this.elementRef.nativeElement as HTMLElement;
    const nodesLength = nativeElement.children.length;
    const elementContent = nativeElement.innerHTML;
    const lastNode = nativeElement.children[nodesLength - 1] as HTMLElement;

    const content = this.seeMoreScrollContent();
    const forceShow = this.seeMoreForceShow();

    // Remove existing 'Läs mer' elements to prevent duplicates
    const existingElements = nativeElement.querySelectorAll('.' + this.elementCssClass());
    existingElements.forEach((element) => {
      this.renderer.removeChild(element.parentNode, element);
    });

    if ((lastNode || elementContent !== '') && ((content && content !== '') || forceShow)) {
      const linkContent = this.renderer.createElement('span');
      this.renderer.setStyle(linkContent, 'color', 'var(--green-1)');
      this.renderer.setStyle(linkContent, 'cursor', 'pointer');
      this.renderer.setAttribute(linkContent, 'class', this.elementCssClass());
      const text = this.renderer.createText(' Läs mer');
      this.renderer.appendChild(linkContent, text);
      const period = this.renderer.createText('.');

      if (nodesLength === 0) {
        this.renderer.appendChild(nativeElement, linkContent);
        this.renderer.appendChild(nativeElement, period);
      } else {
        this.renderer.appendChild(lastNode, linkContent);
        this.renderer.appendChild(lastNode, period);
      }
    }
  }
}
